import React, { FC } from "react";
import { makeStyles, IconButton, Box } from "@material-ui/core";
import colors from "../constants/colors";

interface ISlideIndicatorProps {
  slideIndex: number;
  selectSlide: (index: number) => void;
}

interface ISlideCircleProps {
  active?: boolean;
}

export const SlideIndicator: FC<ISlideIndicatorProps> = ({
  slideIndex,
  selectSlide,
}) => {
  const classes = styles();
  return (
    <Box className={classes.container}>
      <IconButton className={classes.button} onClick={() => selectSlide(0)}>
        <SlideCircle active={slideIndex === 0} />
      </IconButton>
      <IconButton className={classes.button} onClick={() => selectSlide(1)}>
        <SlideCircle active={slideIndex === 1} />
      </IconButton>
      <IconButton className={classes.button} onClick={() => selectSlide(2)}>
        <SlideCircle active={slideIndex === 2} />
      </IconButton>
    </Box>
  );
};

const SlideCircle: FC<ISlideCircleProps> = ({ active = false }) => {
  const classes = styles(active);
  return <Box className={classes.circle} />;
};

const styles = makeStyles((active: boolean) => ({
  container: {
    margin: "50px 0 20px 0",
    display: "flex",
  },
  button: {
    padding: 5,
  },
  circle: {
    margin: 3,
    backgroundColor: active ? colors.primary : "transparent",
    borderColor: colors.primary,
    borderWidth: 0.5,
    borderStyle: "solid",
    height: 20,
    width: 20,
    borderRadius: 10,
  },
}));
